import { clone, isEmpty } from 'lodash';
import { SeismicActionTypes } from '~/actions/seismic';
import moment from '~/_moment';

const eventDefault = {
  data: [],
  pagination: {
    current: 0,
    perPage: 0,
    totalPage: 0,
    totalData: 0,
  },
};

const initialData = {
  isLoading: true,
  threshold: {
    alert: 0,
    log: 0,
  },
  event: { ...eventDefault, pagination: { ...eventDefault.pagination, totalData: -1 } },
  stream: {
    station: '',
    requestTime: moment(),
    startTime: moment(),
    endTime: moment(),
    data: [],
  },
};

const initialState = initialData;

export default (state = initialState, action) => {
  const { type, ...param } = action;
  switch (action.type) {
    case SeismicActionTypes.LOAD_EVENT:
      if (!isEmpty(param)) {
        if (param.info.total_data === 0) {
          return {
            ...state,
            isLoading: false,
            event: eventDefault,
          };
        }

        const {
          logging_info: { log, alarm },
          info: { current_data: currentData, total_data: totalData },
          data,
          page,
          records_per_page: perPage,
        } = param;

        return {
          ...state,
          isLoading: false,
          threshold: {
            alert: alarm,
            log,
          },
          event: {
            data: data.map((item) => ({ ...item, timestamp: moment(item.timestamp) })),
            pagination: {
              current: page,
              perPage,
              currentData,
              totalPage: Math.ceil(totalData / perPage),
              totalData,
            },
          },
        };
      }

      return { ...state, event: initialData.event, isLoading: false };

    case SeismicActionTypes.LOAD_SEISMIC:
      if (!isEmpty(param)) {
        const {
          result: {
            location: { station },
            quarter: { start_time: startTime, end_time: endTime },
            stream,
            request_time: requestTime,
          },
        } = param;

        return clone({
          ...state,
          isLoading: false,
          stream: {
            station,
            requestTime: moment(requestTime),
            startTime: moment(startTime),
            endTime: moment(endTime),
            data: stream,
          },
        });
      }

      return {
        ...state,
        stream: initialData.stream,
        isLoading: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/reducers/seismic.js